/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import Spinner from '@atlaskit/spinner';

import {
  RelativeLoadingStringStyled,
  RelativeLoadingStyled,
} from './Loading.styled';

export default class RelativeLoading extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    text: <span>Loading ...</span>,
    spinnerSize: 'xlarge',
    fontSize: 'xx-large',
  };

  render() {
    return (
      <>
        <RelativeLoadingStyled>
          <Spinner size={this.props.spinnerSize} />
        </RelativeLoadingStyled>
        <RelativeLoadingStringStyled style={{ fontSize: this.props.fontSize }}>
          {this.props.text}
        </RelativeLoadingStringStyled>
      </>
    );
  }
}
